import { RouteRecordRaw } from 'vue-router';

export const routes: Array<RouteRecordRaw> = [
  {
    path: 'requests-dispatcher',
    name: 'RequestsDispatcherList',
    component: () => import('~/views/requests-dispatcher/RequestsDispatcherList.vue'),
    meta: {
      title: 'Заявки',
    }
  },
  {
    path: 'requests-dispatcher/detail/:id',
    name: 'RequestDetailItem',
    component: () => import('~/views/requests-dispatcher/RequestDetailItem.vue'),
    meta: {
      title: 'Заявка',
    }
  },
  {
    path: 'requests-dispatcher/add-request',
    name: 'RequestAdd',
    component: () => import('~/views/requests-dispatcher/RequestAdd.vue'),
    meta: {
      title: 'Новая заявка',
    }
  },
  {
    path: 'requests-dispatcher/accept/:id',
    name: 'RequestAccept',
    component: () => import('~/views/requests-dispatcher/actions/RequestAccept.vue'),
    meta: {
      title: 'Принять заявку',
    }
  },
  {
    path: 'requests-dispatcher/close/:id',
    name: 'RequestClose',
    component: () => import('~/views/requests-dispatcher/actions/RequestClose.vue'),
    meta: {
      title: 'Закрыть заявку',
    }
  },
  {
    path: 'requests-dispatcher/perform/:id',
    name: 'RequestPerform',
    component: () => import('~/views/requests-dispatcher/actions/RequestPerform.vue'),
    meta: {
      title: 'Выполнить заявку',
    }
  },
  {
    path: 'requests-dispatcher/unperform/:id',
    name: 'RequestUnperform',
    component: () => import('~/views/requests-dispatcher/actions/RequestUnperform.vue'),
    meta: {
      title: 'Переоткрыть заявку',
    }
  },
  {
    path: 'requests-dispatcher/move/:id',
    name: 'RequestMove',
    component: () => import('~/views/requests-dispatcher/actions/RequestMove.vue'),
    meta: {
      title: 'Перевести заявку',
    }
  },
  {
    path: 'requests-dispatcher/unlock/:id',
    name: 'RequestUnlock',
    component: () => import('~/views/requests-dispatcher/actions/RequestUnlock.vue'),
    meta: {
      title: 'Отписаться от заявки',
    }
  },
  {
    path: 'requests-dispatcher/shutdowns',
    name: 'Shutdowns',
    component: () => import('~/views/requests-dispatcher/Shutdowns.vue'),
    meta: {
      title: 'Отключения',
    }
  },
];